import React, {Component} from 'react';

class SearchingTitleComponent extends Component {
    constructor(props){
        super(props)

    }

    render(){
        var { onError} = this.props;
        return(
            <div style = {{ flexDirection:'row',display:'flex', alignItems:'center', alignContent:'center', width:this.props.width || '40%', height:40, borderRadius:20,  backgroundColor: '#99e4ff'}}>
                { !this.props.error ? 
                <h4 style = {{color: '#00394d', textAlign:'center', alignSelf:'center',  width:'101%', fontSize: this.props.fontSize || 20}}> Loading</h4>
                :<h4 style = {{color: '#00394d', textAlign:'center', alignSelf:'center',  width:'101%', fontSize: this.props.fontSize || 20, cursor:'pointer'}} onClick = {() => {
                    /**onError() + " - Click to Load"*/
                }}> {this.props.error }</h4>
                }
            </div>
        )
    }
}

export default SearchingTitleComponent